import { createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles(() =>
  createStyles({
    root: {},
    button: {},
    flexContainer: {},
    subtitle: {
      color: '#000A8C',
      fontSize: 26,
      marginTop: 15,
    },
    stockageMode: {
      '&>svg': {
        color: '#0E1247',
      },
      '&>fieldset': {
        borderColor: '#0E1247',
      },
      '&>div': {
        paddingTop: 12,
        paddingBottom: 12,
      },
    },
    select: {
      fontFamily: 'Poppins',
    },
    marginTop: {
      marginTop: 15,
    },
    checkedIcon: {
      backgroundColor: 'transparent',
      borderRadius: 5,
      border: '1px solid #000A8C',
      padding: 2,
      '&:before': {
        display: 'block',
        width: 16,
        height: 16,
        content: '""',
        backgroundColor: '#000A8C',
        borderRadius: 4,
      },
    },
    iconC: {
      borderRadius: 5,
      width: 16,
      height: 16,
      backgroundColor: 'white',
      border: '1px solid #000A8C',
      padding: 2,
      '$root.Mui-focusVisible &': {
        outline: '2px auto rgba(19,124,189,.6)',
        outlineOffset: 2,
      },
      'input:hover ~ &': {
        backgroundColor: '#ebf1f5',
      },
      'input:disabled ~ &': {
        boxShadow: 'none',
        background: 'rgba(206,217,224,.5)',
      },
    },
    formInput: {
      width: '100%',
      fontSize: 14,
      maxWidth: 100,
      '& div fieldset': {
        borderColor: '#0E1247',
      },
      '& div input': {
        paddingTop: 12,
        paddingBottom: 12,
      },
    },
    text: {
      fontFamily: 'Open Sans',
      fontSize: 12,
      fontStyle: 'normal',
      fontWeight: 600,
      textTransform: 'none',
      color: '#4C8612',
      position: 'absolute',
      left: '61%',
      top: '100%',
      display: 'flex',
      alignItems: 'center',
      textWrap: 'nowrap',
    },
    textTimer: {
      display: 'flex',
      flexDirection: 'column',
    },
    label: {
      fontSize: 18,
      fontFamily: 'Poppins',
      fontWeight: 600,
      color: '#151528',
      marginBottom: 5,
    },
    error: {
      '& div fieldset': {
        borderColor: `red !important`,
      },
    },
    fullWidth: {
      width: '100%',
    },
    labelMinMax: {
      fontFamily: 'Poppins',
      fontSize: 14,
    }
  })
);

export default useStyles;
